import { InjectionToken } from '@angular/core'
import { environment } from '../../../environments/environment'

export interface FeatureFlags {
  isCompanyPortfolioFeaturesEnabled: boolean
  isSmallDVOfferCreationEnabled: boolean
}

export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('Stage-dependent feature toggles', {
  providedIn: 'root',
  factory: (): FeatureFlags => environment.featureFlags,
})
